export default "__VITE_ASSET__5bdbcd44__"